import { render, staticRenderFns } from "./medicalReportDetails.vue?vue&type=template&id=c4f16428"
import script from "./medicalReportDetails.vue?vue&type=script&lang=js"
export * from "./medicalReportDetails.vue?vue&type=script&lang=js"
import style0 from "./medicalReportDetails.vue?vue&type=style&index=0&id=c4f16428&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports